import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router';
import * as Sentry from '@sentry/vue';
import { API } from '@vp/common';
import { permissions } from '@vp/vue-components';
import { useAccountStore } from '@/stores/account';
import { useFeatures } from '@/composables/useFeatures';

const { PermissionKey, PermissionLevel } = API.App.Permission.UserPermission;

/** Keeps a webhooks route to accounts with webhooks on and viewers holding at least `level` on webhooks. */
const requireWebhooksLevel = (level: API.App.Permission.UserPermission.PermissionLevel) => async (to: RouteLocationNormalized): Promise<true | RouteLocationRaw> => {
  const accountStore = useAccountStore();
  const { can, ensurePermissions } = permissions.usePolicy();

  try {
    // Both app roots render the router before their boot load finishes, so a direct navigation gets here first.
    await Promise.all([ensurePermissions(), accountStore.accountConfig ? undefined : accountStore.loadAccountConfig()]);

    if (useFeatures().hasFeature('outbound_webhooks') && can(level, PermissionKey.SettingsWebhooks)) {
      return true;
    }
  } catch (error) {
    Sentry.captureException(error);
  }

  return { name: 'Calendar', query: to.query };
};

export const requireWebhooksEdit = requireWebhooksLevel(PermissionLevel.Edit);

export const requireWebhooksRead = requireWebhooksLevel(PermissionLevel.Read);
